/**
 * 本中文语言包文档说明：
 * 1.本js采用exports的方式暴露了一个语言包对象；
 * 2.最小对象单位中的key和value提取自OMS2.0标品的所有定制页面及定制弹窗的中文变量；
 * 3.上述中的key按首字母升序排列。
 */


const r3 = require('./r3zh.js')

const dictionary = Object.assign({}, {

  com: {
    
  },

  btn: {

  },

  unit: { // 单位
    yuan: '元',
    volume: '体积(cm3)',
    grossWeight: '毛重',
    netWeight: '净重',
    unit: '单位',
  },

  tip: {},
  
}, r3)

module.exports = dictionary

